import { PageParameters } from '../../../lib/api/types';
import { getDistinctFieldValues } from '../../../modules/databases/databases.repository';

export const getDistinctFieldValuesUseCase = (
  databaseSlug: string,
  tableSlug: string,
  fieldName: string,
  pageParameters: PageParameters,
  query?: string,
) => {
  return getDistinctFieldValues(
    databaseSlug,
    tableSlug,
    fieldName,
    pageParameters,
    query,
  );
};
